/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { Map, fromJS, List } from 'immutable';
import { putError } from '../store/error.store';
import { RestAPI } from '../util/net';

const DEFAULT_STORE_NODE_VALUE = Map();

const storeRolesConfig = (state, data) => state.set('config', fromJS(data));

const updateRoleConfigStore = (state, data) => state.set('config',
  state.get('config', new List()).map(r => r.get('id') == data.id ? fromJS(data) : r));  //eslint-disable-line

export const rolesConfigReducer = (state = DEFAULT_STORE_NODE_VALUE, action) => {
  switch (action.type) {
    case 'ROLES_CONFIG_RETRIEVE_SUCCESSFUL' :
      return storeRolesConfig(state, action.data);
    case 'ROLES_CONFIG_UPDATE_SUCCESSFUL':
      return updateRoleConfigStore(state, action.data);
    default:
      return state;
  }
};

export const retrieveRolesConfig = (dispatch) => {
  dispatch({ type: 'ROLES_CONFIG_RETRIEVE_STARTED' });
  return RestAPI.get('/roles/api')
    .then((data) => {
      dispatch({ type: 'ROLES_CONFIG_RETRIEVE_SUCCESSFUL', data });
      return true;
    },
    (data) => {
      dispatch({ type: 'ROLES_CONFIG_RETRIEVE_FAILED' });
      putError(dispatch, data);
      return true;
    }
    );
};

export const updateRoleConfig = (dispatch, dto) => {
  dispatch({ type: 'ROLES_CONFIG_UPDATE_STARTED', data: dto });
  return RestAPI.patch(`/roles/api/${dto.id}`, dto)
    .then((data) => {
      dispatch({ type: 'ROLES_CONFIG_UPDATE_SUCCESSFUL', data });
      return true;
    },
    (data) => {
      dispatch({ type: 'ROLES_CONFIG_UPDATE_FAILED' });
      putError(dispatch, data);
      return true;
    }
    );
};
